import { Group, Radio, Stack, Text } from '@mantine/core'
import { ApprovalTypeOptions } from '../../../utils/constants'
import classes from '../../css/ApprovalTypeStep.module.css'

interface ApprovalTypeStepProps {
  approvalType: string | null
  setApprovalType: (value: string) => void
}

function ApprovalTypeStep(props: ApprovalTypeStepProps) {
  const { approvalType, setApprovalType } = props
  return (
    <Radio.Group value={approvalType} onChange={setApprovalType} maw={600}>
      <Stack pt='md' gap='md'>
        {ApprovalTypeOptions.map((item) => (
          <Radio.Card
            className={classes.root}
            radius='md'
            value={item.value}
            key={item.value}
            p={32}
          >
            <Group wrap='nowrap' align='center' gap={32}>
              <Radio.Indicator />
              <div>
                <Text fw={700} fz={24}>
                  {item.name}
                </Text>
                <Text mt={8} fz={14}>
                  {item.description}
                </Text>
              </div>
            </Group>
          </Radio.Card>
        ))}
      </Stack>
    </Radio.Group>
  )
}

export default ApprovalTypeStep
